import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export function Contact() {
  const { t } = useLanguage();

  const handleViewMap = () => {
    // Opens Google Maps with the temple address
    window.open('https://www.google.com/maps/place/Sri+Cherman+Arunachalaswamy+Temple/@8.4932903,77.5745616,17z/data=!3m1!4b1!4m6!3m5!1s0x3b0469e909a17ddf:0xccac0dbaf7c69a19!8m2!3d8.493285!4d77.5771365!16s%2Fg%2F11gm9zj3kg?authuser=0&entry=ttu&g_ep=EgoyMDI1MTEzMC4wIKXMDSoASAFQAw%3D%3D', '_blank');
  };

  return (
    <section id="contact" className="contact">
      <div className="contact__container">
        <div className="contact__header">
          <h2 className="contact__title">{t('contact.title')}</h2>
          <p className="contact__description">
            {t('contact.description')}
          </p>
        </div>

        <div className="contact__grid">
          <div className="contact__card">
            <div className="contact__icon">
              <MapPin size={24} />
            </div>
            <h3 className="contact__card-title">{t('contact.address')}</h3>
            <p className="contact__card-text">
              Sri Cherman Kovil, 
              Savalaikaranakulam,   <br />
              Nanguneri (taluk),  <br />
              Tirunelveli (district)   <br />
              Kalakad
              <br />
          
            </p>
            <button
              onClick={handleViewMap}
              className="contact__map-link"
            >
              {t('contact.viewMap')}
            </button>
          </div>

          <div className="contact__card">
            <div className="contact__icon">
              <Phone size={24} />
            </div>
            <h3 className="contact__card-title">{t('contact.phone')}</h3>
            <p className="contact__card-text">
              +91 9750514949<br />
              +91 8098197796
            </p>
          </div>

          <div className="contact__card">
            <div className="contact__icon">
              <Mail size={24} />
            </div>
            <h3 className="contact__card-title">{t('contact.email')}</h3>
            <p className="contact__card-text">
              omcherman.bala@gmail.com<br />
              velaiahjiguru@gmail.com
            </p>
          </div>

          <div className="contact__card">
            <div className="contact__icon">
              <Clock size={24} />
            </div>
            <h3 className="contact__card-title">{t('contact.hours')}</h3>
            <p className="contact__card-text">
              {t('contact.dailyHours')}<br />
              {t('contact.openDays')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
